import { render } from "./tabToggle.vue?vue&type=template&id=70c3e385&scoped=true"
import script from "./tabToggle.vue?vue&type=script&lang=js"
export * from "./tabToggle.vue?vue&type=script&lang=js"

import "./tabToggle.vue?vue&type=style&index=0&id=70c3e385&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c3e385"]])

export default __exports__